// @flow

import type { BasicProps, EasyAction } from '../../type'

import * as React from 'react'

type Props = BasicProps & {};
export default class XqkdPboc extends React.PureComponent<Props> {
  static actions: EasyAction[] = [
    {
      title: 'form的post提交',
      name: 'toUnionPay'
    }
  ];

  actionToUnionPay = () => {
    const sform = window.document.all.sform
    if (sform) {
      sform.submit()
    }
  };

  render () {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/plugin/XqkdPboc.js